import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1824f2b2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  class: "dis-space-2 me-main-title"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dis dis-space-1 me-content"
}, " 如有业务咨询，欢迎在线留言，我们将及时联系您！ ", -1));
const _hoisted_4 = {
  class: "right"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_button = _resolveComponent("a-button");
  return _openBlock(), _createElementBlock("div", {
    class: "service",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1), _hoisted_3]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_a_button, {
    class: "service-btn dis-space-2 me-content",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.openModdal())
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.buttonTxt), 1)]),
    _: 1
  })])], 4);
}